import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import circlebig from "../assets/images/pattern/circle-big.svg";
import circlebig2 from "../assets/images/pattern/circle-2.svg";
import apiClient from "../api/apiClient";

const FALLBACK = [
  {
    id: 1,
    name: "Richard Harrison",
    role: "Personal Trainer",
    rating: 5,
    message: "Hybrid Performance Academy completely transformed my training approach. The structured video libraries and expert coaching have taken my performance to a new level.",
    avatar_url: null,
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    role: "Fitness Enthusiast",
    rating: 5,
    message: "The platform makes it so easy to follow structured programs. I've seen incredible results in just 8 weeks following the strength-focused library.",
    avatar_url: null,
  },
  {
    id: 3,
    name: "Omar Khalil",
    role: "Athlete",
    rating: 5,
    message: "Best investment I've made in my fitness journey. The content quality and coaching expertise is unmatched.",
    avatar_url: null,
  },
];

const StarRating = ({ rating }) => (
  <ul className="testimonial-rating justify-content-start wow fadeInUp">
    {[1, 2, 3, 4, 5].map((n) => (
      <li key={n}>
        <i className={`fa-${n <= rating ? "solid" : "regular"} fa-star`} style={{ color: n <= rating ? "#f5a623" : "#555" }} />
      </li>
    ))}
  </ul>
);

const Testimonial = () => {
  const swiperRef = useRef(null);
  const [items, setItems] = useState(FALLBACK);

  useEffect(() => {
    apiClient.get("/homepage/testimonials")
      .then(({ data }) => { if (data && data.length > 0) setItems(data); })
      .catch(() => {});
  }, []);

  return (
    <>
      <div className="swiper swiper-fade testimonial-swiper swiper-btn-lr">
        <Swiper
          className="swiper-wrapper"
          loop={true}
          speed={1300}
          ref={swiperRef}
        >
          {items.map((item, ind) => (
            <SwiperSlide className="swiper-slide" key={item.id || ind}>
              <div className="testimonial-1 testimonial-left testimonial-no-photo">
                <div className="testimonial-info wow fadeInUp">
                  <StarRating rating={item.rating || 5} />
                  <p className="testimonial-text">{item.message}</p>
                  <h4 className="testimonial-name">{item.name}</h4>
                  <span className="testimonial-position text-primary">{item.role}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          onClick={() => swiperRef.current.swiper.slidePrev()}
          className="testimonial-button-prev btn-prev"
        >
          <i className="fa-solid fa-arrow-left"></i>
        </div>
        <div
          onClick={() => swiperRef.current.swiper.slideNext()}
          className="testimonial-button-next btn-next"
        >
          <i className="fa-solid fa-arrow-right"></i>
        </div>
      </div>

      <img className="svg-shape rotate-360" src={circlebig} alt="" />
      <img className="svg-shape-2 rotate-360" src={circlebig2} alt="" />
    </>
  );
};

export default Testimonial;
